import { ParamMap } from '@angular/router';
import { Observable, distinctUntilChanged, filter, map } from 'rxjs';

/**
 * The patient id of the open file, every time it changes. Angular keeps the same file component when only the id in
 * the URL changes (a link to another patient followed from the chat window, for one), so a snapshot read once would
 * leave the previous patient on screen.
 */
export function patientIdChanges(paramMap: Observable<ParamMap>): Observable<string> {
  return paramMap.pipe(
    map((params) => params.get('id')),
    filter((id): id is string => !!id),
    distinctUntilChanged(),
  );
}
